// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".juniper-highlight-card[data-v-323ab60f]{background-color:rgba(51,203,154,.06);border-color:rgba(51,203,154,.1);border-radius:.25rem;border-width:1px;display:flex;flex-direction:column;gap:.5rem 4rem;justify-content:space-between;padding:1rem}@media (min-width:640px){.juniper-highlight-card[data-v-323ab60f]{flex-direction:row}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
